import React from 'react';
import { bookingShape, locationShape } from 'constants/propTypes';
import { withBooking } from 'components/queries/GetBookingQuery';
import { getAssistances, getValidExtras } from 'utils/booking';
import { StyledStickyContainer } from '../BookingDetails.styles';
import BookingDetailsTable from '../BookingDetailsTable';
import ModuleTabs from '../ModuleTabs';
import Notes from './Notes';
import { getVoidedProduct } from 'utils/booking';
import { OPERATIONAL_REMARK_ADDITIONAL_DETAILS_KEY } from 'constants/booking';

const Index = ({ booking, location }) => {
  const journeyExtras = [...booking.outboundExtras, ...booking.inboundExtras];
  const assistances = getAssistances(journeyExtras);
  const voidedProduct = getVoidedProduct({ status: booking.status, outbound: booking.outbound, inbound: booking.inbound });
  const currentRemark = booking.additionalDetails?.find((ad) => ad.key === OPERATIONAL_REMARK_ADDITIONAL_DETAILS_KEY);

  const filteredExtras = [
    ...getValidExtras(booking.outboundExtras),
    ...getValidExtras(booking.insurances),
    ...getValidExtras(booking.hotels),
    ...getValidExtras(booking.inboundExtras),
    ...getValidExtras(booking.travelPassProducts)
  ];

  const bookingDates = {
    confirmedTimestamp: booking.confirmedTimestamp,
    cancelledTimestamp: booking.cancelledTimestamp,
    expiryTimestamp: booking.expiryTimestamp,
    voidExpiryDate: !!voidedProduct && voidedProduct?.expiryTimestamp,
    createTimestamp: booking.createTimestamp,
    updatedTimestamp: booking.updatedTimestamp
  };

  return (
    <>
      <StyledStickyContainer id="booking-details">
        <BookingDetailsTable booking={booking} />
        <ModuleTabs
          notes={booking.notes}
          reference={booking.reference}
          outbound={booking.nonExchangedOutbound}
          inbound={booking.nonExchangedInbound}
          assistances={assistances}
          extras={filteredExtras}
          booking={booking}
        />
      </StyledStickyContainer>
      <Notes
        booking={booking}
        bookingReference={booking.reference}
        notes={booking.notes}
        location={location}
        dates={bookingDates}
        currentRemark={currentRemark}
        bookingStatus={booking.status}
      />
    </>
  );
};

Index.propTypes = {
  booking: bookingShape,
  location: locationShape
};

const options = {
  centerLoader: true
};
export default withBooking(Index, undefined, options);
